import { APP_ENV } from './appEnv';

export const API = {
  LOGIN: `${APP_ENV.API_URL}/auth/login`,
  VIDEO_DETAIL: `${APP_ENV.API_URL}/video/detail`,
  VIDEO_LIST: `${APP_ENV.API_URL}/video/list`,
  VIDEO_DOWNLOAD_URL: `${APP_ENV.API_URL}/video/download_url`,
  VIDEO_DOWNLOAD_COUNT: `${APP_ENV.API_URL}/video/download_count`,
} as const;
